import type { Product } from "@/graphql/codegen/graphql"
import { ComputedProductStatus } from "@/graphql/codegen/graphql"
import useProductsForInstructionList from "@/screens/ManageProducts/components/Instructions/hooks/useProductsForInstructionList"
import type { AutocompleteOption } from "@/types/form-fields"

interface UseParametrizedParametrizedProductsForInstructionListReturn {
  products: Product[]
  fetchingProducts: boolean
  noProductsFoundMessage: string
}

const ACTIVE_PRODUCT_STATUSES = [ComputedProductStatus.Active, ComputedProductStatus.PendingApproval]

const useParametrizedProductsForInstructionList = ({
  searchQuery,
  showInactive,
}: {
  searchQuery: string | AutocompleteOption
  showInactive: boolean
}): UseParametrizedParametrizedProductsForInstructionListReturn => {
  const isSearchQueryString = typeof searchQuery === "string"

  // searchQuery can be a string or a exact product selected in suggestion list
  const filter = isSearchQueryString ? { query: searchQuery } : { productIds: [Number(searchQuery.id)] }

  const { products, fetchingProducts } = useProductsForInstructionList({
    ...filter,
    computedProductStatuses: showInactive ? undefined : ACTIVE_PRODUCT_STATUSES,
    pause: !(isSearchQueryString ? searchQuery.length > 1 : !!searchQuery?.id),
  })

  const noProductsFoundMessage = `No products found for "${isSearchQueryString ? searchQuery : searchQuery.label}"`

  return {
    products,
    fetchingProducts,
    noProductsFoundMessage,
  }
}

export default useParametrizedProductsForInstructionList
